/* eslint-disable eqeqeq */
import { useState } from "react";
import { useForm } from "react-hook-form";

import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { LiHandleButton, LoadingButton } from "../../Utils/CustomComponent";
import { Button } from "react-bootstrap";
import FormBox from "../../components/FormBox/FormBox";
import { RenderComp } from "../SALForm/index2";
import { loanOnboardingArr } from "./Constants";

const LoanOnbaording = () => {
  const [activeTab, setActiveTab] = useState(0);
  const schema = tabButtons.at(activeTab)?.validation
    ? tabButtons.at(activeTab)?.validation
    : null;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    // ...schema
  });

  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = async (data, func) => {
    // console.log(data, "data")
    // func();
    // if (activeTab === 8) {
    //   setSubmitLoading(true);
    //   const id = toast.loading("Loan Submission Pending");
    //   try {
    //     // const headers = {
    //     //   headers: {
    //     //     "Content-Type": "application/json",
    //     //   },
    //     // };
    //     // await axios.post(
    //     //   urls.submitaLoan.postSubmitaLoan(),
    //     //   {
    //     //     user_id: localStorage.getItem("apex_userid"),
    //     //     loan_submission_details: data,
    //     //   },
    //     //   headers
    //     // );
    //     toast.update(id, {
    //       render: "Loan Submitted Succesfuly",
    //       type: "success",
    //       isLoading: false,
    //       ...commonToast,
    //     });
    //     setSubmitLoading(false);
    //   } catch (error) {
    //     console.error(error);
    //     toast.update(id, {
    //       render: "Error",
    //       type: "error",
    //       isLoading: false,
    //       ...commonToast,
    //     });
    //   }
    // }
  };
  const handleNextClick = () => {
    if (activeTab !== 5) {
      const func = () => setActiveTab((data) => data + 1);
      handleSubmit(onSubmit)(func);
    }
  };
  const handleBtnClick = (value) => {
    const func = () => setActiveTab(value);
    func();
    // handleSubmit(onSubmit)(func);
  };
  const handleBackClick = () => {
    if (activeTab !== 0) {
      setActiveTab((data) => data - 1);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded loan-onboarding-form"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h6>
              <a href="/loan-onboarding" style={{ textDecoration: "none" }}>
                Loan Onboarding
              </a>{" "}
              / Loan File
            </h6>
          </div>
        </article>
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="row"></div>
            <h4 className="mt-5">Loan Onboarding</h4>
            <div className="loan-details">
              <div className="pt-5 mt-5">
                <ul className="nav nav-tabs ">
                  {tabButtons?.map((data, index) => (
                    <LiHandleButton
                      key={index}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      label={data.label}
                      value={index}
                      handleBtnClick={handleBtnClick}
                    />
                  ))}
                </ul>
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="loans-in-details mt-5">
                {loanOnboardingArr()?.map((data, index) => {
                  return activeTab == index ? (
                    <RenderComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                  ) : null;
                })}

                <div className="col-sm-10">
                  {activeTab !== 0 && (
                    <Button onClick={handleBackClick} className="me-2">
                      Back
                    </Button>
                  )}
                  {activeTab !== 5 && (
                    <Button onClick={handleNextClick} className="me-2">
                      Next
                    </Button>
                  )}
                  {activeTab === 5 && (
                    <LoadingButton
                      loading={submitLoading}
                      type="submit"
                      title={"Submit"}
                    />
                  )}
                </div>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};

export default LoanOnbaording;

let tabButtons = [
  {
    label: <p>Borrowers</p>,
    // validation: salGeneralFormOptions,
  },
  {
    label: <p>Properties</p>,
  },
  {
    label: <p>Funding</p>,
  },
  {
    label: <p>Terms</p>,
  },
  {
    label: <p>Lenders</p>,
  },
  //   {
  //     label: <p>Checklist</p>,
  //   },
];
